import type { Directive } from 'vue';

const PIXELATED_STYLES: Record<string, string> = {
  imageRendering: 'pixelated',
};

// All the vendor-prefix / legacy values applied as a block via cssText manipulation.
// We store them on a data attribute so we can cleanly remove them later.
const PIXELATED_CSS = ['image-rendering: optimizeSpeed', 'image-rendering: -moz-crisp-edges', 'image-rendering: -o-crisp-edges', 'image-rendering: -webkit-optimize-contrast', 'image-rendering: optimize-contrast', '-ms-interpolation-mode: nearest-neighbor', 'image-rendering: pixelated'].join('; ');

function applyPixelated(el: HTMLElement) {
  el.style.cssText += '; ' + PIXELATED_CSS;
  el.dataset.pixelatedScale = 'true';
}

function removePixelated(el: HTMLElement) {
  // Remove every property set by applyPixelated by parsing the stored list.
  el.style.removeProperty('image-rendering');
  el.style.removeProperty('-ms-interpolation-mode');
  delete el.dataset.pixelatedScale;
}

export const vPixelatedScale: Directive<HTMLElement, boolean> = {
  mounted(el, binding) {
    if (binding.value) {
      applyPixelated(el);
    }
  },
  updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    if (binding.value) {
      applyPixelated(el);
    } else {
      removePixelated(el);
    }
  },
  beforeUnmount(el) {
    removePixelated(el);
  },
};
